// src/pages/admin/settings/ViewSystemUser.js
import React from 'react';
import { Layout, Button } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar'; // Updated path

const { Content } = Layout;

const ViewSystemUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = React.useState(false);

  const user = { id, name: 'Placeholder', email: 'placeholder@jecthub.com', role: 'ADMIN', status: 'Active' }; // Placeholder

  const handleMenuClick = ({ key }) => {
    navigate(`/admin/${key}`);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} handleMenuClick={handleMenuClick} />
      <Layout>
        <Content style={{ margin: '16px', padding: '16px', background: '#fff' }}>
          <h2>User Details: {user.name}</h2>
          <p><strong>ID:</strong> {user.id}</p>
          <p><strong>Name:</strong> {user.name}</p>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Role:</strong> {user.role}</p>
          <p><strong>Status:</strong> {user.status}</p>
          <Button onClick={() => navigate('/admin/system-users')}>Back</Button>
        </Content>
      </Layout>
    </Layout>
  );
};

export default ViewSystemUser;